<template>
  <a-modal
    title="Truck location"
    :visible="visible"
    @ok="$emit('close')"
    okText="Close"
    :cancelButtonProps="cancelButtonProps"
  >
    <div v-if="loading" class="loading-spinner">
      <a-spin />
    </div>

    <div v-else>
      <div v-if="error">
        We couldn't find any live tracking data for this truck.
      </div>
      <div v-else>
        <GmapMap
          class="movements-map"
          :zoom="mapZoom"
          :center="mapCenter"
          v-if="directionsAreReady"
        >
          <Gmap-Marker :position="mapCenter" />
        </GmapMap>

        <div v-if="assetLocations.length > 0" class="movements-info">
          <p class="h5 mb-3">Most Recent Position</p>
          <p class="h6">
            <strong>{{
              assetLocations[0].time.format("h:mm a, Do MMMM YYYY")
            }}</strong>
          </p>
          <p class="h6 text-muted">{{ assetLocations[0].address }}</p>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import moment from "moment";
import DirectionsRenderer from "../../maps/DirectionsRenderer.js";
import FreightMateMovementsStep from "../../steps/FreightMateMovements";

export default {
  props: {
    booking: {
      type: Object
    },

    visible: {
      type: Boolean,
      default: false
    },

    cancelButtonProps: {
      type: Object,
      default: () => ({
        style: { display: "none" }
      })
    }
  },

  components: {
    FreightMateMovementsStep,
    DirectionsRenderer
  },

  data() {
    return {
      loading: true,
      isLoadingLocations: false,
      directionsAreReady: false,
      directions: {},
      mapZoom: 18,
      assetLocations: [],
      error: false
    };
  },

  methods: {
    moment,

    loadLocation() {
      this.loading = true;
      axios
        .get("/send-freight/bookings/" + this.booking.id + "/truck-location")
        .then(response => {
          console.log(response.data);
          this.assetLocations = this.mapRawAssetLocations(response.data);
          this.showDirections();
        })
        .catch(error => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    showDirections() {
      let directionsService = new google.maps.DirectionsService();
      const that = this;
      const assetLocations = [...this.assetLocations];
      const length = assetLocations.length;
      let wayPoints = [];
      if (length > 2) {
        wayPoints = assetLocations.slice(1, length - 1).map(location => {
          return {
            stopover: true,
            location: {
              lat: location.lat,
              lng: location.lng
            }
          };
        });
      }
      const request = {
        origin: {
          lat: assetLocations[length - 1].lat,
          lng: assetLocations[length - 1].lng
        },
        destination: {
          lat: assetLocations[0].lat,
          lng: assetLocations[0].lng
        },
        waypoints: wayPoints,
        avoidTolls: false,
        avoidHighways: false,
        travelMode: google.maps.TravelMode.DRIVING
      };
      directionsService.route(request, function(response, status) {
        if (status === google.maps.DirectionsStatus.OK) {
          that.directions = response;
          that.directionsAreReady = true;
        } else {
          console.log("Directions request failed due to " + status);
          console.log(response);
        }
      });
    },

    mapRawAssetLocations(rawLocations) {
      return [
        {
          id: rawLocations.id,
          address: rawLocations.address,
          time: moment(rawLocations.time),
          lat: rawLocations.lat,
          lng: rawLocations.lng
        }
      ];
    }
  },

  watch: {
    visible(value) {
      if (value) {
        this.loadLocation();
      }
    }
  },

  computed: {
    mapCenter: function() {
      if (this.assetLocations.length === 0) {
        return {
          lat: -41.543,
          lng: 174.0277
        };
      }
      return {
        lat: this.assetLocations[0].lat,
        lng: this.assetLocations[0].lng
      };
    }
  }
};
</script>

<style scoped>
.loading-spinner {
  text-align: center;
  border-radius: 4px;
  padding: 30px 50px;
}

.movements-map {
  margin: -24px;
  height: 300px;
}

.movements-info {
  margin-top: 48px;
}

>>> .ant-steps-dot .ant-steps-item-content,
.ant-steps-dot.ant-steps-small .ant-steps-item-content {
  width: inherit;
}
</style>
